/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Verdi Dashboard API
 * API behind the Verdi irrigation dashboard: organizations, their devices, zones and irrigation schedules, and the sensor data those devices report.
 *
 * ## Authentication
 *
 * Most operations need a Descope session token, sent as `Authorization: Bearer <token>`. Each operation's `security` lists what it accepts. Role and permission names there, such as `Verdi Administrator`, are Descope roles or permissions the session must carry, and the operation's description repeats them under **Access**. Operations with `security: []` are public.
 *
 * ## Organization context
 *
 * Data belongs to organizations. A user's session acts as their primary organization, or as another organization they belong to when its ID is sent in the `User` header. Administrators must send the `User` header on organization-scoped operations, or the request is rejected with a 400.
 *
 * ## Errors
 *
 * Error bodies are JSON `{ "message": string }`.
 *
 * - **400**: the path, query or body failed validation, or the request broke a domain rule.
 * - **401 / 403**: sent by the auth middleware; the body may be empty.
 * - **409**: see below.
 * - **500**: an unexpected server error.
 *
 * ## Versioned resources
 *
 * Versioned resources carry a `versionId`. Send the `versionId` you last read on a PATCH (in the body) or a DELETE (as a query parameter). If the resource changed since, the request gets a 409: reload it and retry. A 409 that includes a `code` is a conflict specific to that operation, described on the operation. On a create, 409 means the resource already exists.
 *
 * ## Reads with a request body
 *
 * Some reads take their input as a JSON body on the HTTP `QUERY` method; these operations are marked `x-read-only: true`. Deprecated POST and GET variants serve clients that cannot send `QUERY`.
 *
 * ## Identifiers
 *
 * MongoDB ObjectIds are 24-character hexadecimal strings.
 * OpenAPI spec version: 1.0.0
 */

export type ExportDataStreamsCsvBodyHeaderRowsItem =
	(typeof ExportDataStreamsCsvBodyHeaderRowsItem)[keyof typeof ExportDataStreamsCsvBodyHeaderRowsItem];

export const ExportDataStreamsCsvBodyHeaderRowsItem = {
	DATA_STREAM_ID: "DATA_STREAM_ID",
	FRAGMENT_ID: "FRAGMENT_ID",
	DATA_STREAM_NAME: "DATA_STREAM_NAME",
	DEVICE_NAME: "DEVICE_NAME",
	DEVICE_VERDI_ID: "DEVICE_VERDI_ID",
	ZONE: "ZONE",
	SENSOR_TYPE: "SENSOR_TYPE",
	UNIT_CATEGORY: "UNIT_CATEGORY",
	UNIT: "UNIT",
	DEPTH: "DEPTH",
	HEIGHT: "HEIGHT",
	LATITUDE: "LATITUDE",
	LONGITUDE: "LONGITUDE",
} as const;
